import { validateEmail } from "utils";
import SuperCarersOperations from "logic/SuperCarersOperations";

export const validateField = async (name, value) => {
  if (name === "lastname" && !value) {
    return "Full name required";
  }
  if (name === "phone_number") {
    try {
      await SuperCarersOperations.validatePhoneNumber(value);
    } catch (e) {
      return "Invalid phone number";
    }
  }
  if (name === "email" && !validateEmail(value)) {
    return "Invalid email";
  }
  return null;
};

export const validateFields = async (formData, fieldNames) => {
  if (!formData || !fieldNames) {
    return null;
  }
  const validationObject = await fieldNames.reduce(async (acc, name) => {
    const invalidEntry = await validateField(name, formData[name]);
    const accummulator = await acc;
    const emptyField = !formData[name];
    if (invalidEntry) {
      accummulator[name] = invalidEntry;
    } else if (emptyField) {
      accummulator[name] = "Required";
    } else {
      accummulator[name] = null;
    }
    return accummulator;
  }, {});
  return validationObject;
};
